export default "__VITE_ASSET__7030b21a__"